import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageDelivery1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPackageDelivery1"><Path d="M21 3H3V21H14V19.5H4.5V4.5H8V10H16V4.5H19.5V11H21V3Z" fill="currentColor"/><Path d="M20.9019 13.5995C19.4374 12.1335 17.0626 12.1335 15.5981 13.5995C14.134 15.0651 14.134 17.441 15.5981 18.9066L18.25 21.5612L20.9019 18.9066C22.366 17.441 22.366 15.0651 20.9019 13.5995Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageDelivery1;
